import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useAuthStore } from '../store/authStore';

interface UseDataFetchingOptions<T> extends Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn' | 'enabled'> {
  queryFn: () => Promise<T>;
  enabled?: boolean;
}

export function useDataFetching<T>(
  queryKey: string[],
  options: UseDataFetchingOptions<T>
) {
  const { isAuthenticated } = useAuthStore();
  const { queryFn, enabled = true, ...queryOptions } = options;

  // React Query will automatically refetch when queryKey changes
  // We need to ensure staleTime is 0 so it always refetches on queryKey change
  const query = useQuery({
    ...queryOptions,
    queryKey,
    queryFn,
    enabled: isAuthenticated && enabled,
    staleTime: 0, // Always consider data stale
    refetchOnMount: true, // Refetch when component mounts
  });

  return query;
}
